import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";

export function useScreenToWorld() {
  const cropper = useCropperStore();
  const get = (pxX, pxY) => {
    const { cropBox } = cropper.element.cropper;
    // const coreBox = dragContainer.current.firstElementChild.getBoundingClientRect();
    
    const cropBoxRect = cropBox.getBoundingClientRect();

    // Limiti per evitare che coreBox esca da cropBox
    const maxX = cropBoxRect.width;
    const maxY = cropBoxRect.height;

    // Assicuriamoci che la nuova posizione non esca dai limiti del cropBox
    const newX = Math.max(0, Math.min(pxX - cropBoxRect.left, maxX));
    const newY = Math.max(0, Math.min(pxY - cropBoxRect.top, maxY));

    // Calcoliamo le percentuali rispetto alla larghezza e altezza del cropBox
    const percentageX = cropBoxRect.width ? (newX / cropBoxRect.width) * 100 : 0;
    const percentageY = cropBoxRect.height ? (newY / cropBoxRect.height) * 100 : 0;
    return {
      x: percentageX,
      y: percentageY,
    }
  }

  return get;
}